module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _getPrototypeOf = __webpack_require__(2), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(3), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(4), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(5), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(6), _inherits3 = _interopRequireDefault(_inherits2), _react = __webpack_require__(7), _react2 = _interopRequireDefault(_react), _popper = __webpack_require__(8), _popper2 = _interopRequireDefault(_popper), _utilSharedStyles = __webpack_require__(9), _helpers = __webpack_require__(10), Layer = function(_PureComponent) {
        function Layer(props) {
            (0, _classCallCheck3.default)(this, Layer);
            var _this = (0, _possibleConstructorReturn3.default)(this, (Layer.__proto__ || (0, 
            _getPrototypeOf2.default)(Layer)).call(this, props));
            return _this.extractStyles = function(state) {
                if (state) {
                    var left = Math.round(state.offsets.popper.left), top = Math.round(state.offsets.popper.top);
                    _this.setState({
                        // position: fixed or absolute
                        cssPosition: state.offsets.popper.position,
                        transform: "translate3d(" + left + "px, " + top + "px, 0px)",
                        // state.flipped is either true or undefined
                        flipped: !!state.flipped,
                        actualPosition: state.position,
                        originalPosition: state.originalPosition
                    });
                }
            }, _this.state = {
                position: null,
                transform: null,
                flipped: !1,
                actualPosition: null,
                originalPosition: null
            }, _this;
        }
        return (0, _inherits3.default)(Layer, _PureComponent), (0, _createClass3.default)(Layer, [ {
            key: "componentDidMount",
            value: function() {
                this.applyPopper(this.props);
            }
        }, {
            key: "componentWillReceiveProps",
            value: function(nextProps) {
                this.applyPopper(nextProps);
            }
        }, {
            key: "componentDidUpdate",
            value: function(prevProps, prevState) {
                prevState.flipped !== this.state.flipped && this.props.onFlippedChange({
                    flipped: this.state.flipped,
                    actualPosition: this.state.actualPosition,
                    originalPosition: this.state.originalPosition
                });
            }
        }, {
            key: "componentWillUnmount",
            value: function() {
                this.popper && this.popper.destroy();
            }
        }, {
            key: "applyPopper",
            value: function(props) {
                if (this.targetRef && this.contentRef) {
                    this.popper && this.popper.destroy();
                    // we wrap our target in a div so that we can safely get a reference to it, but we pass the
                    // actual target to popper
                    var actualTarget = this.targetRef.firstChild;
                    this.popper = new _popper2.default(actualTarget, this.contentRef, {
                        placement: (0, _helpers.positionPropToPopperPosition)(props.position),
                        onCreate: this.extractStyles,
                        onUpdate: this.extractStyles,
                        modifiers: {
                            applyStyle: {
                                enabled: !1
                            },
                            hide: {
                                enabled: !1
                            },
                            offset: {
                                enabled: !0,
                                offset: this.props.offset
                            },
                            flip: {
                                enabled: this.props.autoPosition,
                                flipVariations: !0,
                                boundariesElement: this.props.boundariesElement,
                                padding: 0
                            },
                            preventOverflow: {
                                enabled: this.props.autoPosition,
                                escapeWithReference: !0
                            }
                        }
                    });
                }
            }
        }, {
            key: "render",
            value: function() {
                var _this2 = this, _state = this.state, cssPosition = _state.cssPosition, transform = _state.transform;
                return _react2.default.createElement("div", null, _react2.default.createElement("div", {
                    ref: function(_ref) {
                        return _this2.targetRef = _ref;
                    }
                }, this.props.children), _react2.default.createElement("div", {
                    ref: function(_ref2) {
                        return _this2.contentRef = _ref2;
                    },
                    style: {
                        top: 0,
                        left: 0,
                        position: cssPosition,
                        transform: transform,
                        zIndex: _utilSharedStyles.akZIndexLayer
                    }
                }, this.props.content));
            }
        } ]), Layer;
    }(_react.PureComponent);
    /* eslint-enable react/no-unused-prop-types */
    Layer.propTypes = {
        position: _react.PropTypes.oneOf(_helpers.POSITION_ATTRIBUTE_ENUM.values),
        boundariesElement: _react.PropTypes.oneOf([ "viewport", "window", "scrollParent" ]),
        autoPosition: _react.PropTypes.bool,
        offset: _react.PropTypes.string,
        content: _react.PropTypes.node,
        onFlippedChange: _react.PropTypes.func,
        children: _react.PropTypes.node
    }, Layer.defaultProps = {
        position: _helpers.POSITION_ATTRIBUTE_ENUM.default,
        boundariesElement: "viewport",
        autoPosition: !0,
        offset: "0 0",
        content: null,
        onFlippedChange: function() {},
        children: null
    }, exports.default = Layer;
}, /* 2 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("popper.js");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/util-shared-styles");
}, /* 10 */
/***/
function(module, exports) {
    "use strict";
    function positionPropToPopperPosition(position) {
        return positionMap[position] ? positionMap[position].position : positionMap[POSITION_ATTRIBUTE_ENUM.default].position;
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var positionMap = {
        "top left": {
            position: "top-start",
            animation: "top"
        },
        "top center": {
            position: "top",
            animation: "top"
        },
        "top right": {
            position: "top-end",
            animation: "top"
        },
        "right top": {
            position: "right-start",
            animation: "right"
        },
        "right middle": {
            position: "right",
            animation: "right"
        },
        "right bottom": {
            position: "right-end",
            animation: "right"
        },
        "bottom left": {
            position: "bottom-start",
            animation: "bottom"
        },
        "bottom center": {
            position: "bottom",
            animation: "bottom"
        },
        "bottom right": {
            position: "bottom-end",
            animation: "bottom"
        },
        "left top": {
            position: "left-start",
            animation: "left"
        },
        "left middle": {
            position: "left",
            animation: "left"
        },
        "left bottom": {
            position: "left-end",
            animation: "left"
        }
    }, POSITION_ATTRIBUTE_ENUM = {
        values: [ "top left", "top center", "top right", "right top", "right middle", "right bottom", "bottom left", "bottom center", "bottom right", "left top", "left middle", "left bottom" ],
        default: "right middle"
    };
    exports.positionPropToPopperPosition = positionPropToPopperPosition, exports.POSITION_ATTRIBUTE_ENUM = POSITION_ATTRIBUTE_ENUM;
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/@atlaskit/layer/dist/bundle-cjs.js
// module id = 298
// module chunks = 0